let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("45WLE")).then(() => parcelRequire('O74aM'));